<template>
    <!-- 数字展厅 -->
    <div class="guide-wrapper w-100">
        <!-- 列表头部 -->
        <div class="com-list-header">
            <el-form class="com-search-box" :model="form" ref="form" label-width="90px">
                <el-row type="flex" :gutter="20">
                    <!-- <el-col :span="6">
                        <el-form-item class="mb-20" label="订单号：">
                            <el-input v-model="form.name" placeholder="请输入订单号"></el-input>
                        </el-form-item>
                    </el-col> -->

                    <el-col :span="6">
                        <el-form-item label="预约日期：" prop="dateRange">
                            <el-date-picker @change="handleTimeChange" v-model="value1" type="daterange"
                                value-format="yyyy-MM-dd" start-placeholder="开始日期" end-placeholder="结束日期">
                            </el-date-picker>
                        </el-form-item>
                    </el-col>

                    <!-- <el-col :span="6">
                        <el-form-item label="开放状态：">
                            <el-select v-model="form.type" placeholder="请选择开放状态">
                                <el-option v-for="item in statusList" :key="item.value" :label="item.label"
                                    :value="item.value">
                                </el-option>
                            </el-select>
                        </el-form-item>
                    </el-col> -->

                    <el-col :span="18">
                        <div class="tr">
                            <el-button type="primary" @click="getTableList">查询</el-button>
                            <el-button @click="resetForm('form')">重置</el-button>
                        </div>
                    </el-col>

                </el-row>
            </el-form>
        </div>

        <!-- 列表内容 -->
        <div class="com-list-content">

            <div class="button">
                <el-row type="flex">
                    <el-col>
                        <!-- <el-button class="el-primary-border" round @click="settingTime">
                            <svg-icon icon-class="add" />&nbsp;时间预设
                        </el-button> -->

                        <!-- <el-button type="danger" round @click="handleAdd('add')">
                            <i class="el-icon-delete" />&nbsp;批量闭馆
                        </el-button> -->
                    </el-col>
                    <el-popover placement="bottom" width="150" trigger="click">
                        <el-checkbox-group @change="handleCheck" v-model="checkList">
                            <el-checkbox :label="item.propName" v-for="(item, i) in checkLabels" :key="i"
                                style="display: block;">{{
                                    item.label }}</el-checkbox>
                        </el-checkbox-group>
                        <span class="icon-wrapper" slot="reference">
                            <svg-icon icon-class="shaixuan" class-name="icon-menu" />
                        </span>
                    </el-popover>

                    <el-popover class="pop-wrapper" placement="bottom" width="150" trigger="click">
                        <span class="icon-wrapper" slot="reference">
                            <svg-icon icon-class="export" class-name="icon-menu" />
                        </span>
                    </el-popover>

                    <span class="icon-wrapper">
                        <svg-icon icon-class="print" class-name="icon-menu" />
                    </span>

                </el-row>
            </div>
            <!-- 表格 -->
            <div class="table mt-20">
                <el-table ref="multipleTable" v-loading="listLoading" :row-key="(row) => { return row.id }" stripe
                    :data="tableData">
                    <el-table-column type="selection" :reserve-selection="true" width="42"></el-table-column>
                    <template v-for="item in checkLabels">
                        <el-table-column v-if="item.show" :prop="item.propName" :label="item.label" :key="item.label"
                            show-overflow-tooltip>
                            <template slot-scope="scope">
                                <span v-if="scope.column.property === 'openState'">
                                    {{ scope.row[scope.column.property] | filterOpenState }}
                                </span>

                                <span v-else>{{ scope.row[scope.column.property] }}</span>
                            </template>
                        </el-table-column>
                    </template>
                    <!-- 操作 -->
                    <el-table-column fixed="right" width="250" label="操作">
                        <template slot-scope="scope">
                            <a class="m-btn mr-10 m-danger" @click="handleState(scope.row)">{{ scope.row.openState == 1 ?
                                '闭馆' : '开馆' }}</a>
                            <!-- <a class="m-btn mr-10" @click="handleEdit(scope.row)">编辑</a> -->
                            <a class="m-btn mr-10" @click="handleTicket(scope.row)">余票设置</a>
                            <a class="m-btn mr-10" @click="handleReverse(scope.row)">预约信息</a>

                        </template>
                    </el-table-column>
                </el-table>

                <div class="pagination-container paging">
                    <el-pagination :current-page="listQuery.currentPage" :page-size="listQuery.size" :total="total"
                        background layout="total, prev, pager, next, sizes, jumper" @size-change="handleSizeChange"
                        @current-change="handleCurrentChange" />
                </div>
            </div>
        </div>
        <dialog-time-setting ref="dialogTimeSetting"></dialog-time-setting>
        <dialog-info ref="dialogInfo"></dialog-info>
    </div>
</template>
  
<script>
import dialogTimeSetting from './dialogs/dialog-time-setting'
import dialogInfo from './dialogs/dialog-info'


export default {
    data() {
        return {
            form: {
                dateRange: '',
            },
            value1: '',
            checkLabels: [{ label: '日期', show: true, propName: 'dateStr' }, { label: '开放状态', show: true, propName: 'openState' }, { label: '开放票数', show: true, propName: 'openSumStr' }, { label: '预约票数', show: true, propName: 'appointedSumStr' }, { label: '剩余票数', show: true, propName: 'surplusSumStr' }, { label: '已入馆数量', show: true, propName: 'entrySumStr' }, { label: '未入馆数量', show: true, propName: 'unentrySumStr' }],
            checkList: [],
            listLoading: true,
            listQuery: {
                currentPage: 1,
                size: 10
            },
            total: 0,
            tableData: [],
            chooseRowIds: '',
        }
    },
    filters: {
        filterOpenState(val) {
            if (val == 0) {
                return '闭馆'
            } else if (val == 1) {
                return '正常开馆'
            } else {
                return ''
            }
        }
    },

    watch: {
        $route: {
            handler(to, from) {
                this.$nextTick(() => {
                    this.$refs['form'].resetFields()
                })
                this.total = 0
                this.value1 = []
                this.chooseRowIds = ''
                this.listQuery = { currentPage: 1, size: 10 }
                this.setHead()
                this.getData()
            },
            immediate: true
        }
    },

    components: { dialogTimeSetting, dialogInfo },
    methods: {
        // 项目列表
        getData() {
            this.listLoading = true
            this.tableData = []
            this.$api.appointSetting.getTicketList({
                ...this.form,
                orgId: this.$route.query.orgId,
                ...this.listQuery
            }).then(res => {
                this.listLoading = false
                if (res.success) {
                    this.tableData = res.result
                    this.total = res.page.allRow
                } else {
                    this.$message.error(res.message)
                }
            })
        },

        handleTimeChange(time) {
            this.form.dateRange = time[0] + ' - ' + time[1]
        },

        settingTime() {
            this.$refs.dialogTimeSetting.init()
        },

        handleSelectionChange(list) {
            let arr = []
            list.forEach(item => {
                arr.push(item.id)
            })
            this.chooseRowIds = arr.join(',')
        },

        setHead() {
            this.checkLabels.map(item => {
                this.checkList.push(item.propName)
            })
        },

        // 动态修改表头
        handleCheck(key) {
            for (let i = 0; i < this.checkLabels.length; i++) {
                if (this.checkList.includes(this.checkLabels[i].propName)) {
                    this.checkLabels[i].show = true;
                } else {
                    this.checkLabels[i].show = false;

                }
            }
        },


        // 重置查询
        resetForm() {
            this.$refs['form'].resetFields()
            this.value1 = []
            this.listQuery.currentPage = 1
            this.getData()
        },

        // 查询
        getTableList() {
            this.listQuery.currentPage = 1
            this.getData()
        },

        handleEdit(obj) {
            this.$refs.dialogInfo.init()
        },
        handleTicket(obj) {
            this.$router.push({
                path: '/reservation/list/ticket',
                query: { ticketId: obj.id, date: obj.dateStr.slice(0, 10) }
            })
        },
        // 删除
        handleDelete(obj) {
            this.$common
                .confirm1('是否确认删除?')
                .then(function () {
                    // return delCollection(obj.id)
                })
                .then(res => {
                    if (res.code == 0) {
                        this.$message.success('删除成功')
                        this.getData()
                    } else {
                        this.$message.error(res.msg || '系统异常')
                    }
                })
                .catch(() => { })

            return
            this.$common.confirm(
                {
                    content: `是否确认删除？`,
                    title: '系统提示',
                }, () => {
                    this.$api.applet.delDigitalExhibition({ id: obj.id }).then(res => {
                        if (res.success) {
                            this.$message.success('删除成功')
                            this.getData()
                        } else {
                            this.$message.error(res.message)
                        }
                    })
                }
            )
        },

        handleState(obj) {
            this.$common.confirm1(`是否确认${obj.openState == 1 ? '闭馆' : '开馆'}?`)
                .then(() => {
                    this.$api.appointSetting.setTicketState({ id: obj.id, openState: obj.openState == 1 ? '0' : '1' }).then(res => {
                        if (res.success) {
                            this.$message.success('设置成功')
                            this.getData()
                        } else {
                            this.$message.error(res.message || '系统异常')
                        }
                    }).catch(() => { })
                })

        },


        handleReverse(obj) {
            this.$router.push({
                path: '/reservation/list/reservelist',
                query: { id: obj.id, orgId: this.$route.query.orgId }
            })
        },

        // 表格分页
        handleSizeChange(val) {
            this.listQuery.size = val
            this.getData()
        },
        // 点击序号
        handleCurrentChange(val) {
            this.listQuery.currentPage = val
            this.getData()
        },

        onSubmit() {
            const self = this
            this.$refs["form"].validate((valid) => {
                if (valid) {
                    let url = "addDigitalExhibition"
                    if (this.addForm.id) {
                        url = "updateDigitalExhibition"
                    }
                    this.$api.applet[url](this.addForm).then(res => {
                        if (res.success) {
                            this.$message.success({
                                message: this.addForm.id ? '数字展厅修改成功' : '新增数字展厅成功',
                                duration: 500,
                                onClose() {
                                    self.dialogVisible = false
                                    self.addForm = {}
                                    self.imgUrl = ""
                                    self.getData()
                                }
                            })
                        }
                    })
                } else {
                    return false;
                }
            });
        },

        guide(obj) {
            this.$router.push({
                path: '/applet-management/guide-management',
                query: { guideId: obj.id }
            })
        },
    },

    beforeUpdate() {
        this.$nextTick(() => { //在数据加载完，重新渲染表格
            this.$refs['multipleTable'].doLayout()
        })
    },

    // created() {
    //     this.setHead()
    //     this.getData()
    // }
}
</script>
  
<style lang="scss" scoped>
.guide-wrapper {
    .com-list-header {
        padding-right: 30px;

        .el-row--flex {
            flex-wrap: wrap;
        }
    }

    .com-list-content {
        .el-row--flex {
            justify-content: end;
        }
    }

    .icon-wrapper {
        display: flex;
        width: fit-content;
        padding: 6px;
        margin-left: 20px;
        border: 1px solid #ccc;
        justify-content: center;
        align-items: center;

        &:hover {
            cursor: pointer;
            border: 1px solid #999;
            transition: .5s all;

        }

        .icon-menu {
            font-size: 20px;
        }
    }

    /deep/ .el-button--danger span {
        color: #fff;
    }
}
</style>